<template lang="pug">
.content-wrapper
  FITHeader(:showAddNewFitBtn="false", :idClinic="+idClinic")
  .card.router-view-card
    router-view()
</template>

<script>
import { defineComponent } from "vue";
import FITHeader from "@/components/fit-kit/FITHeader.vue";

export default defineComponent({
  components: { FITHeader },

  data() {
    return {
      idClinic: null,
    };
  },

  methods: {},

  created() {
    if (this.$route.params.idClinic === null) return;
    this.idClinic = this.$route.params.idClinic;
  },
});
</script>

<style scoped lang="scss">
.content-wrapper {
  position: relative;
  padding-bottom: 40px;
}
.router-view-card {
  padding-top: 0;
  padding-bottom: 45px;
  position: relative;
  width: 100%;
  box-shadow: none;
  z-index: 1;
}
</style>
